// extracted by mini-css-extract-plugin
export default {"componentWrapper":"FiltersSwitcher_componentWrapper__sxhOn","icon":"FiltersSwitcher_icon__n4bmH","active":"FiltersSwitcher_active__ZLZH2","name":"FiltersSwitcher_name__1kVyV"};